const resetPassword = {
  stepProgress: "الخطوة {step}/{total}",
  step1: {
    title: "إعادة تعيين كلمة المرور",
    subtitle:
      "أدخل عنوان بريدك الإلكتروني المسجل وكلمة المرور المؤقتة المرسلة إلى {email} لإعادة تعيين كلمة المرور.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "أدخل البريد الإلكتروني",
    temporaryPassword: "كلمة المرور المؤقتة",
    temporaryPasswordPlaceholder: "أدخل كلمة المرور المؤقتة",
  },
  step2: {
    title: "إعادة تعيين كلمة المرور",
    subtitle: "اختر كلمة مرور جديدة لـ {email}.",
    currentPassword: "كلمة المرور الحالية",
    currentPasswordPlaceholder:
      "أدخل كلمة المرور المؤقتة أو الحالية",
    newPassword: "كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أكد كلمة المرور الجديدة",
    confirmMatchAria: "كلمتا المرور متطابقتان",
    rules: {
      length: "يجب أن تتكون من 8 أحرف على الأقل.",
      complexity:
        "تشمل حرفًا كبيرًا وحرفًا صغيرًا ورقمًا وحرفًا خاصًا واحدًا.",
    },
  },
  success: {
    title: "تم إعادة تعيين كلمة المرور بنجاح!",
    description:
      "يرجى تسجيل الدخول باستخدام بريدك الإلكتروني المسجل وكلمة المرور الجديدة.",
  },
  next: "التالي",
  reset: "إعادة تعيين كلمة المرور",
  backToLogin: "العودة لتسجيل الدخول",
};

export default resetPassword;
